import { ShieldCheck, MapPin, BookOpen, Radar } from "lucide-react";

/** Franja de confianza / prensa. Mientras no haya menciones reales,
 *  mostramos badges verificables: hecho en Chile, basado en la ley + decreto, escaneos hechos. */
export default function PressStrip() {
  const items = [
    { icon: MapPin, label: "Hecho en Chile" },
    { icon: BookOpen, label: "Basado en la Ley 21.719 y el Decreto 662" },
    { icon: Radar, label: "Miles de sitios escaneados" },
    { icon: ShieldCheck, label: "Pago seguro con Webpay" },
  ];
  return (
    <section
      data-testid="press-strip"
      className="w-full bg-white border-y border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-6 py-6 grid grid-cols-2 md:grid-cols-4 gap-4 items-center">
        {items.map(({ icon: Icon, label }) => (
          <div key={label} className="flex items-center gap-3 justify-center md:justify-start">
            <span className="w-8 h-8 rounded-lg bg-slate-100 grid place-items-center shrink-0">
              <Icon className="w-4 h-4 text-slate-700" />
            </span>
            <span className="text-xs sm:text-sm font-medium text-slate-700 leading-tight">{label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
